export const properties = {
    url: "https://carly-backend-app.azurewebsites.net"
}
